import { css } from '@emotion/css'

import { fontSize, fontWeight, spacing } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import { colors } from '../../../themes'

const styles = {
  card: css({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: spacing.medium,
    backgroundColor: colors.athensGray,
  }),

  header: css({
    borderBottom: `1px solid ${colors.geyser}`,
    padding: shorthandHelper([spacing.default, spacing.medium]),
    fontSize: fontSize.default,
    fontWeight: fontWeight.semiBold,
    color: colors.oxfordBlue,
  }),

  body: css({
    padding: spacing.medium,
    margin: 0,
    display: 'grid',
    gridTemplateAreas: `
      'quarter quarter'
      'current_month last_month'
    `,
    gridGap: spacing.default,
  }),

  quarter: css({
    gridArea: 'quarter',
  }),

  currentMonth: css({
    gridArea: 'current_month',
  }),

  lastMonth: css({
    gridArea: 'last_month',
  }),
}

export default styles
